import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import moment from 'moment';
import Base from '../js/base.js';
var Search = {
  pn: 'div[data-name=customer-search]',
  init: function init() {
    var self = this;
    $('#customer-search').submit(function (e) {
      var s = $('#customer-search .search-string').val().trim();
      self.search(s);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  },
  search: function () {
    var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(s) {
      var self, loading, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = this;
              $(self.pn + ' .listview').html('');

              if (!(s === '')) {
                _context.next = 5;
                break;
              }

              Base.app.dialog.alert('Chưa gõ SDT em êi...!');
              return _context.abrupt("return", false);

            case 5:
              if (!(s.length < 10)) {
                _context.next = 8;
                break;
              }

              Base.app.dialog.alert('SDT không đủ 10 số em êi...!');
              return _context.abrupt("return", false);

            case 8:
              loading = Base.app.dialog.preloader('Đang tìm nè...!');
              _context.next = 11;
              return Base.api('Customer', 'search', {
                s: s
              });

            case 11:
              rs = _context.sent;
              loading.close();

              if (!(rs.total == 0)) {
                _context.next = 16;
                break;
              }

              Base.app.dialog.alert('Haizzz...! :( Không tìm thấy khách nào có SDT: ' + s);
              return _context.abrupt("return", false);

            case 16:
              if (rs.rows && rs.rows.length > 0) {
                rs.rows.forEach(function (item, i) {
                  $(self.pn + ' .listview').append(self.row(item));
                });
              }

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function search(_x) {
      return _search.apply(this, arguments);
    }

    return search;
  }(),
  row: function row(item) {
    var bday = item.birthDate ? ' <div>Sinh nhật: ' + moment(item.birthDate).format(Base.dateFormat) + '</div>' : '';
    return "\n    <div class=\"block\">\n      <a href=\"/customer-search-popup/".concat(item.code, "\">").concat(item.name, " - ").concat(item.contactNumber, "</a>\n      ").concat(bday, "\n    </div>");
  }
};
export default (function ($prop, ctx) {
  ctx.$on('pageInit', function () {
    Search.init();
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="customer-search">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"></div>
        <div class="title sliding">Tra cứu khách hàng</div>
        <div class="right"><a href="#" @click=${profile}><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="searchbar-backdrop"></div>
    <form class="searchbar" id="customer-search">
      <div class="searchbar-inner">
        <div class="searchbar-input-wrap">
          <input type="search" pattern="[0-9]*" class="search-string" placeholder="Gõ đủ 10 SDT"/>
          <i class="searchbar-icon"></i>
          <span class="input-clear-button"></span>
        </div>
        <span class="searchbar-disable-button">Huỷ</span>
      </div>
    </form>
    <div class="page-content">
      <div class="listview">
      </div>
    </div>
  </div>
`
    }
    ;
});